import angular from 'angular';

import firmwareUpgradeModalComponent from './firmwareUpgradeModal.component';
import addressValidationModalComponent from './addressValidationModal.component';


export default angular.module('fp:customerportal:shop:checkout:modals', [])
    .component('fpFirmwareUpgradeModal', firmwareUpgradeModalComponent)
    .component('fpAddressValidationModal', addressValidationModalComponent);
